/**
 * @generated SignedSource<<6233049f6a5282a5298178880dc96c32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductCarouselItem_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideo_viewer">;
  readonly " $fragmentType": "ProductCarouselItem_viewer";
};
export type ProductCarouselItem_viewer$key = {
  readonly " $data"?: ProductCarouselItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarouselItem_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductVideo_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d1b032a7525bc4a8f6932668572c8c31";

export default node;
